// extracted by mini-css-extract-plugin
export default {"wrapper":"SigninButton_wrapper__UQnJk"};